// Taken from https://emojipedia.org/
export enum Emojis {
  PARTY = `🎉`,
  WAVE = `👋`,
}
